@let isClickable = clickable && (ignoreReadOnly || !userFacadeService.isReadOnly());

<ng-container *ngIf="isClickable; else iconTemplate">
  <button
    (click)="onClick()"
    class="svg-clickable"
    [attr.aria-controls]="aria?.controls"
    [attr.aria-expanded]="aria?.expanded"
    [attr.aria-describedby]="aria?.describedby"
    [attr.aria-label]="aria?.label"
  >
    <ng-template [ngTemplateOutlet]="iconTemplate"></ng-template>
  </button>
</ng-container>

<ng-template #iconTemplate>
  <svg-icon
    [svgClass]="'svg-icon'"
    [src]="icon"
    [svgStyle]="svgStyle"
    [viewBox]="viewBox"
    [svgAriaLabel]="aria?.label ?? ''"
  ></svg-icon>
</ng-template>
